






















































































































































































import Vue from 'vue';
import axios from 'axios';
import {API} from '@/api';

export default Vue.extend({
  data: () => ({
    singleSelect: false,
    row: null,
    selected: [],
    headers: [
      {
        text: 'Dessert (100g serving)',
        align: 'left',
        sortable: true,
        value: 'name',
      },
      { text: 'Calories', value: 'calories' },
      { text: 'Fat (g)', value: 'fat' },
      { text: 'Carbs (g)', value: 'carbs' },
      { text: 'Protein (g)', value: 'protein' },
      { text: 'Iron (%)', value: 'iron' },
    ],
    totalDesserts: 0,
    desserts: [],
    loading: true,
    loading_text: 'Cargando postres',
    options: {},
  }),
  async mounted() {
//    console.debug('mounted helloworld');
  this.$toast.info('Info toast');
  this.$toast.custom('custom toast');
  this.$toast.success('success toast');
  this.$toast.edup('EDUP');
  this.$toast.warning('warn toast');
  this.$toast.error('error toast');
  },
  methods: {
    async pageEventHandler(page) { // cargar mas registros
      try {
      console.debug('page: %o', event);
      this.loading = true;
      const res = await this.getDesserts(this.options);
      console.debug('desserts: %o', res.data.content);
      this.desserts = res.data.content;
      this.totalDesserts = res.data.numberOfElements;
      this.$toast.info('Cargados ' + res.data.numberOfElements);
      } catch (e) {
        this.$toast.error(e);
      }
      this.loading = false;
    },
    eventalert2(event) {
      console.debug('sortBy: %o', event);
    },
    eventalert3(event) {
      console.debug('options: %o', event);
    },
    rowSelected(event) {
      this.row = event;
      this.$router.push({name: 'panda', params: {name: event.name, dessert: event}});
      // los params solo funcionan con name
//    this.$router.push({path:'/panda', params: {name:event.name}});
    },
    getDesserts(options) {
    console.debug('getDesserts');
//  let sortBy = options.sortBy[0] ? options.sortBy[0]: '';
    const sortBy = options.sortBy[0] ? options.sortBy[0] + ',' + (options.sortDesc[0] ? 'desc' : 'asc') : '';
    const queryString = {page: options.page, itemsPerPage: options.itemsPerPage, sort: sortBy};
    console.debug('queryString: %o', queryString);
    const res = axios.get('/desserts.json', {params: queryString});
    return res;
    },
  },
});
